import { createFileRoute } from "@tanstack/react-router";
import { EndpointNew } from "../../features/inference/endpoint-new";

export const Route = createFileRoute("/_authed/$org/$project/inferenceendpoints/new")({
  validateSearch: (s: Record<string, unknown>): { model?: string } => (typeof s.model === "string" && s.model ? { model: s.model } : {}),
  component: NewEndpointPage,
});

function NewEndpointPage() {
  const { org, project } = Route.useParams();
  const { model } = Route.useSearch();
  return <EndpointNew scope={{ org, project }} {...(model ? { model } : {})} />;
}
